var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEyeRingR = function SvgEyeRingR(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 41,
    height: 33,
    viewBox: "0 0 0.73 0.59",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.09;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2316618895920"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.66.41C.68.41.6.47.57.49.36.6.26.53.1.39.26.26.43.25.66.41zM.04.21C.13.11.18.09.31.09.36.09.43.1.49.11M.67.2c.01.01.02.01.02.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.58.07C.47.15.62.26.66.13.67.1.64.09.61.08.6.07.58.07.58.07zM.47.15C.46.1.48.05.54.01.56 0 .58 0 .6 0c.02 0 .03.01.05.02h.01c.05.02.09.05.06.14C.7.22.66.25.62.26.58.26.55.25.52.23.49.21.47.18.47.15z",
    fill: "#000"
  })))));
};

export default SvgEyeRingR;